import actionCreatorFactory from "typescript-fsa";
import { bindThunkAction } from "typescript-fsa-redux-thunk";

import { isFailure } from "../../common/actions/VisitApi";
import { RootState } from "../../state";
import { requestToFollowCompany, requestToUnfollowCompany } from "../api";

const actionCreator = actionCreatorFactory("COMPANY_FOLLOWINGS");

export const followCompany = actionCreator.async<RootState, number, number, Error>("FOLLOWED");
export const unfollowCompany = actionCreator.async<RootState, number, number, Error>("UNFOLLOWED");

export const followCompanyWorker = bindThunkAction(followCompany, async (companyId, dispatch) => {
  const req = requestToFollowCompany(companyId);
  const res = await dispatch(req);
  if (isFailure(res)) {
    throw res.payload.body;
  }
  return companyId;
});

export const unfollowCompanyWorker = bindThunkAction(unfollowCompany, async (companyId, dispatch) => {
  const req = requestToUnfollowCompany(companyId);
  const res = await dispatch(req);
  if (isFailure(res)) {
    throw res.payload.body;
  }
  return companyId;
});



// WEBPACK FOOTER //
// ./frontend/src/company_followings/actions/index.ts